import React from 'react';

export default function check({ width = '17' }) {
  return (
    <svg width={width} viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4484 3.55509L5.78171 14.2218L0.892822 9.33287L2.14616 8.07954L5.78171 11.7062L15.195 2.30176L16.4484 3.55509Z"
        fill="currentColor"
      />
      <mask
        id="mask0jhnbsd7743"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="2"
        width="17"
        height="13"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4484 3.55509L5.78171 14.2218L0.892822 9.33287L2.14616 8.07954L5.78171 11.7062L15.195 2.30176L16.4484 3.55509Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0jhnbsd7743)" />
    </svg>
  );
}
